import { render } from "./About.vue?vue&type=template&id=40c82f94&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=40c82f94&scoped=true&lang=css"

import exportComponent from "/Users/dmitriykuptsov/workspace/front-end-development/strangebit.io/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c82f94"]])

export default __exports__